<template>
  <div class="container">
    <div class="row py-5">
      <div class="col-sm-6"><h1 class="pstitle">{{this.pageTitle}}</h1></div>
      <div class="col-sm-6 text-end">
        <a href="javascript:void(0)" class="pt-1 cursor" :onclick="resetFilter" aria-label="Reset Filters">Reset</a>
      </div>
    </div>
    <div v-if="!this.isNational" class="row">
      <div class="col-xs-12 col-sm-6 col-md-3">
        <SelectOption
          :v-model="selectedModel"
          :value="selectedModel"
          :options="boatModels"
          :onchange="selectModel"
          id="model"
          class="form-control"
        />
        <label for="model" class="form-label">{{formLabel.model}}</label>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-3">
        <SelectOption
          :v-model="selectedYear"
          :value="selectedYear"
          :options="modelYears"
          :onchange="selectYear"
          id="year"
          class="form-control"
        />
        <label for="year" class="form-label">{{formLabel.year}}</label>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-3">
        <SelectOption
          :v-model="selectedPrice"
          :value="selectedPrice"
          :options="priceRanges"
          :onchange="selectPrice"
          id="price"
          class="form-control"
        />
        <label for="price" class="form-label">{{formLabel.price}}</label>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-3">
        <SelectOption
          :v-model="sortBy"
          :value="sortBy"
          :options="sortOptions"
          :onchange="selectSortBy"
          id="sortBy"
          class="form-control"
        />
        <label for="sortBy" class="form-label">Sort By</label>
      </div>
    </div>
    <div v-if="this.isNational" class="row">

        <div class="col-xs-12 col-sm-6 col-md-3">
            <SelectOption :v-model="selectedFamily"
                          :value="selectedFamily"
                          :options="boatFamilies"
                          :onchange="selectFamily"
                          id="family"
                          class="form-control" />
            <label for="family" class="form-label">{{formLabel.family}}</label>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-3">
            <SelectOption :v-model="selectedModel"
                          :value="selectedModel"
                          :options="filteredModels"
                          :onchange="selectModel"
                          id="model"
                          class="form-control" />
            <label for="model" class="form-label">{{formLabel.model}}</label>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-3">
            <SelectOption :v-model="selectedYear"
                          :value="selectedYear"
                          :options="modelYears"
                          :onchange="selectYear"
                          id="year"
                          class="form-control" />
            <label for="year" class="form-label">{{formLabel.year}}</label>
        </div>

        <!--
        <div class="col-xs-12 col-sm-6 col-md-3">
    <multi-select v-model="selectedDealers"
              :options="filterDealers"
              instanceName="Dealers"
              placeholderText="Select Dealers..." />
              -->


        <div class="col-xs-12 col-sm-6 col-md-3 color-container" v-if="colorList.length > 0">
            <color-chooser ref="colorChooser"
                           :colors="colorList"
                           @change="onColorChange">
            </color-chooser>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-3">
            <SelectOption :v-model="selectedEngine"
                          :value="selectedEngine"
                          :options="engineList"
                          :onchange="selectEngine"
                          id="engine"
                          class="form-control" />
            <label for="engine" class="form-label">{{formLabel.Engine}}</label>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-3" v-if="towerList.length > 1">
            <SelectOption :v-model="selectedTower"
                          :value="selectedTower"
                          :options="towerList"
                          :onchange="selectTower"
                          id="tower"
                          class="form-control" />
            <label for="tower" class="form-label">{{formLabel.Tower}}</label>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-3">
            <div class="input-with-search-and-clear">
                <input type="text"
                       class="form-control"
                       id="HIN"
                       placeholder="Enter HIN"
                       v-model="selectedHIN"
                       @blur="HINSelected"
                       @keydown.enter="HINSelected"
                />

                <span v-if="showClearHin"
                      class="clear-hin"
                      aria-label="Clear HIN">
                    <svg @click.prevent.stop="clearHin" width="12" height="12" viewBox="0 0 12 12">
                        <line x1="2" y1="2" x2="10" y2="10" stroke="black" stroke-width="2" />
                        <line x1="2" y1="10" x2="10" y2="2" stroke="black" stroke-width="2" />
                    </svg>
                </span>

                <span 
                  class="search-hin"
                  aria-label="Search HIN">
                    <svg @mousedown.prevent @click="HINSelected(undefined)" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2">
                        <circle cx="11" cy="11" r="7" />
                        <line x1="21" y1="21" x2="16.65" y2="16.65" />
                    </svg>
                </span>

            </div>
            <!--<label for="HIN" class="form-label">{{formLabel.HIN}}</label>-->
        </div>
        <div class="col-xs-12 col-sm-6 col-md-3">
            <div class="textinput-container checkbox-input">

                <div class="checkbox-field">
                    <input type="checkbox"
                           id="saltwater"
                           v-model="isSaltwaterChecked"
                           @change="onSaltWaterCheckChange" />

                    <label for="saltwater" class="checkbox-label">
                        {{ formLabel.SaltwaterPackage }}
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="row py-3">
        <div class="col-xs-12 col-sm-6 compare-boat">
            <a :href="'/Inventory/Compare?ids=' + this.selectedBoatId"
                :disabled="selectedBoatId.length > 1"
                v-if="selectedBoatId.length > 1">Compare Boats</a>
            <span v-else>Compare Boats</span>
        </div>
        <div v-if="!this.isNational" class="col-xs-12 col-sm-6">
            <div class="text-end compare-boat">
                <a :href="website" target="_blank">View {{ brand }} Lineup</a>
            </div>
        </div>
    </div>
    <div class="row">
        <div v-for="boat in boats.data"
                :key="boat.id"
                class="col-12 col-md-6 col-lg-3 mb-4 box">
            <boat-card 
              :boat="boat" 
              :showCompare="true" 
              :checkboxDisabled="isDisabled(boat)" 
              :isChecked="selectedBoatId.includes(boat.boatID)"
              @onCompareCheck="onCheckboxCheck($event)" 
              @onCompareUncheck="onCheckboxUncheck($event)">
            </boat-card>
        </div>
        <div v-if="(boats == null || boats.data == null || boats.data.length == 0) && loading === false" class="col-12">
            <p class="no-boats-message">
                {{noBoatsLabel}}
            </p>
        </div>
        <div>
            <pagination v-model="this.boats.page"
                        :records="this.boats.totalCount"
                        :per-page="this.boats.pageSize"
                        @paginate="getNextPage"
                        aria-label="Pagination"
                        edge-navigation="true" />
        </div>
    </div>
  </div>
</template>

<script>
import getEndPoint, { newBoats, filterBoat, dealerLocationList } from "../constants/api.config";
import { getBrandDetails } from "../constants/brand.config";
import SelectOption from "../components/atoms/SelectOption.vue";
//import CustomCheckBox from "./CustomCheckBox.vue";
import Pagination from "v-pagination-3";
import { boatsPageSize, formLabel, noNewBoats, traderInventory, newInventory } from "../constants/labels.config";
import BoatCard from "../components/atoms/BoatCard";
/*import MultiSelect from "../components/atoms/MultiSelect.vue";*/
import ColorChooser from "../components/atoms/ColorChooser.vue";

export default {
  name: "NewBoatPage",
  data() {
    return {
      brand: getBrandDetails(sessionStorage.getItem("brand"), "brandName"),
      website: getBrandDetails(sessionStorage.getItem("brand"), "brandUrl"),
      nationalGUID: getBrandDetails(sessionStorage.getItem("brand"), "nationalSearchGUID"),
      selectedBoatId: [],
      selectedFamily: "Select Family",
      selectedModel: "Select Model",
      selectedYear: "Select Year",
      selectedPrice: "Select Price",
      selectedHIN: "",
      selectedColor1: "",
      selectedColor2: "",
      requiresBothColors: false,
      selectedEngine: "Select Engine",
      selectedTower: "Select Tower",
      isSaltwaterChecked: false,
      sortBy: "Select Sort Option",
      boats: {
        totalCount: 0,
        pageCount: 0,
        page: 0,
        pageSize: 0,
        data: [],
      },
      boatsPageSize,
      boatFamilies: [],
      boatModels: [],
      filteredModels: [],
      modelYears: [],
      colorList: [],
      engineList: [],
      towerList: [],
      priceRanges: [],
      sortOptions: [
        { value: "Select Sort Option" },
        { value: "Year - Newest to Oldest" },
        { value: "Price - High to Low" },
        { value: "Model - Descending" },
      ],
      filterPrice: [],
      loading: false,
      formLabel,
      noBoatsLabel: noNewBoats,
      filterDealers: [],
      selectedDealers: [],
      isNational: false,
      dealerString: "",
      hinString: "",
      engineString: "",
      towerString: "",
      saltwaterString: "",
    };
  },
  computed: {
    showClearHin() {
      return this.selectedHIN &&
      this.selectedHIN.trim() !== "";
    },
    pageTitle() {
        return this.isNational ? traderInventory : newInventory;
    }
  },
  components: {
    SelectOption,
    Pagination,
    BoatCard,
/*    MultiSelect,*/
    ColorChooser
  },
  mounted() {
    this.checkQueryString();
    this.getNewBoats(1);
    this.getBoatFilter();
/*    this.getDealerFilter();*/
    this.isNational = window.IS_NATIONAL;

    //this.selectedDealers.push(window.DEALER_LOCATION.dealerLocationID);
    this.selectedDealers = [];
    //console.log('national ' + this.isNational);
    //console.log('selected ' + this.selectedDealers.length);
    //console.log('in Mounted window.dealerlocation: ' + window.DEALER_LOCATION.dealerLocationID)
  },

  watch: {
      selectedDealers() {
          this.getNewBoats(1);
      }
  },


  methods: {
    getNextPage(event) {
      this.getNewBoats(event);
    },

    getNewBoats(pageNumber) {

        let family = this.selectedFamily === "Select Family" ? "" : this.selectedFamily;
        let model = this.selectedModel === "Select Model" ? "" : this.selectedModel;
        let year = this.selectedYear === "Select Year" ? "" : this.selectedYear;
        let sort = "&SortColumn=&SortDirection=";

        let minValue = "";
        let maxPrice = "";

        let familyString = "";
        let hinString = "";
        let engineString = "";
        let towerString = "";
        let saltwaterString = "";
        let colorString = this.GetColorString();

        if (this.selectedPrice !== "Select Price") {
        const filteredPrice = this.filterPrice.filter(
            (item) => item.priceRangeLabel === this.selectedPrice
        );
        minValue = filteredPrice[0].minValue ? filteredPrice[0].minValue : "";
        maxPrice = filteredPrice[0].maxValue ? filteredPrice[0].maxValue : "";
        }

        if (this.selectedPrice !== "Select Price") {
        const filteredPrice = this.filterPrice.filter(
            (item) => item.priceRangeLabel === this.selectedPrice
        );
        minValue = filteredPrice[0].minValue ? filteredPrice[0].minValue : "";
        maxPrice = filteredPrice[0].maxValue ? filteredPrice[0].maxValue : "";
        }

        switch (this.sortBy) {
        case "Year - Newest to Oldest":
            sort = "&SortColumn=ModelYear&SortDirection=desc";
            break;
        case "Price - High to Low":
            sort = "&SortColumn=Price&SortDirection=desc";
            break;
        case "Model - Descending":
            sort = "&SortColumn=Model&SortDirection=desc";
            break;
        }

        if (this.selectedDealers && this.selectedDealers.length > 0) {
            this.dealerString = this.selectedDealers
                .map(g => `DealerLocationID=${g.value}`)
                .join("&")
        }
        else {// I guess it must be 0 or null or undefined 
            this.dealerString = '&DealerLocationID=' + window.DEALER_LOCATION.dealerLocationID;
        }

        if (family !== "") {
            familyString = '&Family=' + this.selectedFamily;
        }

        if (this.selectedHIN && this.selectedHIN !== "") {
            hinString = '&HIN=' + this.selectedHIN;
        }

        if (this.selectedEngine && this.selectedEngine !== "" && this.selectedEngine !== "Select Engine") {
            engineString = '&Engine=' + this.selectedEngine;
        }

        if (this.selectedTower && this.selectedTower !== "" && this.selectedTower !== "Select Tower") {
            towerString = '&Tower=' + this.selectedTower;
        }

        if (this.isSaltwaterChecked) {
            saltwaterString = '&SaltwaterPackage=true'
        }

        this.loading = true;
        this.axios
        .get(
            getEndPoint(newBoats) + this.dealerString +
            "&Brand=" +
            this.brand +
            "&Model=" +
            model +
            "&ModelYear=" +
            year +
            familyString +
            hinString +
            engineString +
            towerString +
            saltwaterString +
            colorString +
            sort +
            "&MinPrice=" +
            minValue +
            "&MaxPrice=" +
            maxPrice +
            "&PageSize=" +
            this.boatsPageSize +
            "&PageNo=" +
            pageNumber
        )
        .then((response) => {
            this.loading = false;
            this.boats = response.data;
        })
        .catch((err) => {
            console.log(err);
            this.loading = false;
        });
    },
    getBoatFilter() {
        this.axios
          .get(
            getEndPoint(filterBoat) +
            "IsUsed=false&DealerLocationID=" +
            window.DEALER_LOCATION.dealerLocationID +
            "&Brand=" +
            this.brand
          )
          .then((response) => {
          let boatFamily = response.data.families.map((item) => {
            return { value: item };
          });
          this.boatFamilies = [{ value: "Select Family" }, ...boatFamily];

          let boatModel = response.data.models.map((item) => {
            return { value: item };
          });
          this.boatModels = [{ value: "Select Model" }, ...boatModel];
          this.filteredModels = this.boatModels;

          let modelYear = response.data.modelYears.map((item) => {
            return { value: item };
          });
          this.modelYears = [{ value: "Select Year" }, ...modelYear];

          let boatColor = response.data.colors.map((item) => {
            return { value: item };
          });
          this.colorList = [...boatColor];

          //console.log('boatColor in getboatfilter: ' + boatColor);
          //console.log('colorList in getBoatFilter: ' + this.colorList);

          let engine = response.data.engines.map((item) => {
            return { value: item };
          });
          this.engineList = [{ value: "Select Engine" }, ...engine];

          let tower = response.data.towers.map((item) => {
            return { value: item }
          });
          this.towerList = [{ value: "Select Tower" }, ...tower];

          let priceRange = response.data.priceRanges.map((item) => {
            return { value: item.priceRangeLabel };
          });
          this.priceRanges = [{ value: "Select Price" }, ...priceRange];
          this.filterPrice = response.data.priceRanges;
        })
        .catch((err) => console.log(err));
    },
    getDealerFilter() {
      this.axios
        .get(getEndPoint(dealerLocationList) + "?Country=united%20states&Brand=" + this.brand )
        .then((response) => {
          //let filterDealer = response.data;
          this.filterDealers = response.data.map((item) => {
            return { value: item.dealerLocationID, label: item.name };
          });
        })
      },
    resetFilter() {
      this.selectedBoatId = [];
      this.selectedFamily = "Select Family";
      this.selectedModel = "Select Model";
      this.selectedYear = "Select Year";
      this.selectedPrice = "Select Price";
      this.selectedEngine = "Select Engine";
      this.selectedTower = "Select Tower";
      this.sortBy = "Select Sort Option";
      this.selectedHIN = "";
      this.isSaltwaterChecked = false;
      this.selectedColor1 = "";
      this.selectedColor2 = "";
      if(this.$refs.colorChooser) {
        this.$refs.colorChooser.reset(false); // emits change by default when reset. Here we don't want it bacause it will cause double calls to getNewBoats 
      }
      this.getNewBoats(1);
    },
    selectModel(evt) {
      this.selectedModel = evt.target.value;
      this.getNewBoats(1);
    },
    selectFamily(evt) {
        this.selectedFamily = evt.target.value;
        if (this.selectedFamily !== 'Select Family' && this.selectedFamily !== "") {
            const regex = new RegExp(`^${this.selectedFamily}(\\d|\\s|$)`);
            var tmpModels = this.boatModels.filter(item => regex.test(item.value));
            this.filteredModels = [{ value: "Select Model" }, ...tmpModels];
            this.selectedModel = "Select Model";
        }
        else {
            this.filteredModels = this.boatModels;
        }
        this.getNewBoats(1);
    },
    selectYear(evt) {
      this.selectedYear = evt.target.value;
      this.getNewBoats(1);
    },
    selectEngine(evt) {
      this.selectedEngine = evt.target.value;
      this.getNewBoats(1);
    },
    selectTower(evt) {
      this.selectedTower = evt.target.value;
      this.getNewBoats(1);
    },
    selectPrice(evt) {
      this.selectedPrice = evt.target.value;
      this.getNewBoats(1);
    },
    selectSortBy(evt) {
      this.sortBy = evt.target.value;
      this.getNewBoats(1);
      },
    HINSelected(evt) {
      if(evt != undefined)
      {
        this.selectedHIN = evt.target.value;
      }
        //alert('in HINSelected: ' + this.selectedHIN);
      this.getNewBoats(1);
    },
    clearHin() {
        this.selectedHIN = "";
        this.hinString = "";
        //alert('In clearHin. HIN: ' + this.selectedHIN)
        this.getNewBoats(1);
    },
    onColorChange(evt) {
      this.selectedColor1 = evt.color1;
      this.selectedColor2 = evt.color2;
      this.requiresBothColors = evt.requiresBoth;
      this.getNewBoats(1)
    },
    GetColorString() {
      let retVal = "";
      if (this.selectedColor1) {
          retVal += "&Color1=" + this.selectedColor1;
      }
      if (this.selectedColor2) {
        retVal += "&Color2=" + this.selectedColor2;
          retVal += "&RequireBothColors=" + (this.requiresBothColors ? this.requiresBothColors : 'false')
      }
      return retVal;
    },
    onSaltWaterCheckChange(evt) {
        this.isSaltwaterChecked = evt.target.checked;
        this.getNewBoats(1);
    },
    onCheckboxCheck(evt) {
        this.selectedBoatId.push(evt);
    },
    onCheckboxUncheck(evt) {
      this.selectedBoatId = this.selectedBoatId.filter(
        (item) => item !== evt
      );
    },
    isDisabled(boat) {
        if (!this.selectedBoatId.includes(boat.boatID) && this.selectedBoatId.length >= 4) {
            return true;
        }
        return false;
    },
    checkQueryString() {
        let urlParams = new URLSearchParams(window.location.search);

        let family = urlParams.get('Family');
        if (family) {
            this.selectedFamily = family;
        }
        let model = urlParams.get('Model');
        if (model) {
            this.selectedModel = model;
        }
        let modelYear = urlParams.get('ModelYear');
        if (modelYear) {
            this.selectedYear = modelYear;
        }
        let hin = urlParams.get('HIN');
        if (hin) {
            this.selectedHIN = hin;
        }
        let engine = urlParams.get('Engine');
        if (engine) {
            this.selectedEngine = engine;
        }
        let tower = urlParams.get('Tower');
        if (tower) {
            this.selectedTower = tower;
        }
        let saltwaterPackage = urlParams.get('SaltwaterPackage');
        if (saltwaterPackage) {
            this.isSaltwaterChecked = true;
        }
        let color1 = urlParams.get('Color1');
        let color2 = urlParams.get('Color2');
        if (color1) {
            color1 = color1.toUpperCase();
            if (color2) {
                color2 = color2.toUpperCase();
            }

            this.$nextTick(() => {
                if (this.$refs.colorChooser) {
                    this.$refs.colorChooser.setColors(color1, color2, false, true);
                }
            });

        }
    }
  },
};
</script>
<style lang="scss">

.compare-boat span {
  cursor: not-allowed;
}

.form-control {
  appearance: auto;
}
img {
  max-width: 100%;
  max-height: 100%;
  margin: auto;
  display: block; /*remove extra space below image */
}

.color-container {
    padding-bottom: 2rem;
}
.box {
  display: flex;
  flex-direction: row;
}

    .input-with-search-and-clear {
        position: relative;
    }

    .input-with-search-and-clear input {
      padding-right: 56px;
      padding-bottom: .2rem;
    }

    .search-hin {
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      display: flex;
      align-items: center;
      opacity: 0.6;
    }

    .search-hin:hover {
        opacity: 1;
    }

    .clear-hin {
        position: absolute;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        display: flex;
        align-items: center;
        opacity: 0.6;
    }

    .clear-hin:hover {
        opacity: 1;
    }




    .checkbox-input {
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid #000;

        padding-top: 0.25rem;
        padding-bottom: 0.5rem;
    }


    .checkbox-field {
        display: flex;
        align-items: center;
    }

    .checkbox-field input {
        width: 16px;
        height: 16px;
        cursor: pointer;
        margin-right: 0.5rem;
    }

    .checkbox-label {
        font-size: 1.5rem;
        cursor: pointer;
    }


</style>

